/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import { isCurrentDeviceMobile, isCurrentDeviceTablet } from "dc-preview-utils/src/Utils/DeviceUtils";
import { wrappedPrintButtonContainer as PrintDocument } from "components/topbar/reusableComponents";
import { printHandler } from "print/printHandler";
import { getShouldUseModernViewer } from "selectors/appSelectors";
import * as stores from "stores";
import { isSharedFile } from "utils/DocumentUtils";
import { isMac } from "dc-preview-utils/src/Utils/DeviceUtils";

export const getPrintDocumentAction = props => {
  let shouldShowPrintButton = true;
  if (
    isCurrentDeviceMobile() ||
    isCurrentDeviceTablet() ||
    !props.isPDF ||
    !props.shouldUnblockUIFeatures ||
    (!props.hasAuth && isSharedFile())
  ) {
    shouldShowPrintButton = false;
  }

  if (!props.enablePrintFeature) {
    shouldShowPrintButton = false;
  }
  const printLabel = getShouldUseModernViewer(stores) ? "tooltip.modernViewer.print" : "tooltip.print";
  const ariaLabel = getShouldUseModernViewer(stores) ? "arialabel.modernViewer.print" : "tooltip.print";
  const triggeredFrom = "topbar";
  return shouldShowPrintButton === true
    ? {
        id: "documentPrint",
        label: props.intl.formatMessage({ id: printLabel }),
        ariaLabel: props.intl.formatMessage({ id: ariaLabel }, { shortcut: isMac() ? "Command + P" : "Control + P" }),
        onClick: () => {
          printHandler.print({
            triggeredFrom
          });
        },
        Icon: <PrintDocument showPrintInTopBar />
      }
    : null;
};
